import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import classNames from 'classnames';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { HeaderContext } from '../Header.Context/Header.Context.es.js';

const HeaderHead = ({ as: DynamicTag = 'h1', title, children, ...props })=>{
    const { variant, loading } = useContext(HeaderContext);
    return jsxs("div", {
        className: classNames('cb-header-head', variant),
        ...props,
        children: [
            jsx(DynamicTag, {
                className: "title",
                children: jsx(SkeletonBox, {
                    className: "loading",
                    loading: loading,
                    children: title
                })
            }),
            jsx("div", {
                className: "actions",
                children: children
            })
        ]
    });
};
HeaderHead.displayName = 'Header.Head';

export { HeaderHead };
//# sourceMappingURL=Header.Head.es.js.map
